import axios from 'axios'
import axiosInstance from '../axios'
import { rejectError } from '../helper'

export default {
  state: {
    token: null,
  },
  mutations: {
    setToken (state, token) {
      state.token = token
    },
    clearAuthData (state) {
      state.token = null
    },
  },
  getters: {
    isAuthenticated (state) {
      return state.token !== null
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    login ({ commit }, token) {
      const params = {
        $limit: 1,
      }
      const headers = {
        'X-Access-Token': token,
      }
      return axios.get('/api/v1/assets', {
        params,
        headers,
      })
        .then((result) => {
          localStorage.setItem('token', token)
          return commit('setToken', token)
        })
        .catch((error) => {
          commit('clearAuthData')
          localStorage.removeItem('token')
          return rejectError(error)
        })
    },
    logout ({ commit }) {
      commit('clearAuthData')
      localStorage.removeItem('token')
    },
    // eslint-disable-next-line no-unused-vars
    tryAutoLogin ({ commit, state, dispatch }) {
      const token = localStorage.getItem('token')
      if (!token) {
        return false
      }
      return dispatch('login', token)
    },
    // eslint-disable-next-line no-unused-vars
    getUserToken ({ commit }, userId) {
      const params = {
        user: {
          id: userId,
        },
      }
      return axiosInstance.post('/api/v1/user-access-tokens', params)
        .then((res) => res.data)
        .catch((error) => rejectError(error))
    },
  },
}
